module.exports = __webpack_public_path__ + "img/3.81fb70b6.jpg";